import { FC } from 'react';
import useQueryParams from '@common/src/hooks/useQueryParams';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';
import { useYellowhiveQuotes } from '@flows/src/api/yellowhive-flows';
import { SchemaYellowHiveQuoteCalculationJob } from 'wg-api-sdk';
import YellowhiveFlowProductsSideBarBasketPriceSummary from '@flows/src/components/flow-products/YellowhiveFlowProductsSideBarBasketPriceSummary';
// Remove selected products UI for Yellowhive scenario

const YellowhiveFlowProductsSidebar: FC = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data } = useYellowhiveQuotes({
    sessionId,
    queryOptions: { enabled: !!sessionId },
  });
  const isBasketPage = window.location.pathname.includes('basket');

  const sideBarItems =
    data?.quotes?.reduce(
      (
        uniqueItems: FlowProductsSidebarItem[],
        { insurance }: SchemaYellowHiveQuoteCalculationJob,
      ) => {
        if (!uniqueItems.some((item) => item.key === insurance.code)) {
          uniqueItems.push({
            key: insurance.code,
            label: insurance.name,
          });
        }
        return uniqueItems;
      },
      [] as FlowProductsSidebarItem[],
    ) || [];

  return (
    <FlowProductsSidebar
      items={sideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
      cartComponent={
        isBasketPage ? (
          <YellowhiveFlowProductsSideBarBasketPriceSummary />
        ) : null
      }
      basketItemsComponent={null}
    />
  );
};

export default YellowhiveFlowProductsSidebar;
